module.exports = __webpack_public_path__ + "media/images/about_solution-bg-0fec4439.jpg";